
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
// import Header from '@/components/header'
import './index.less'
import MapComponents from "./MapComponents";

export default function PatrolMap() {
  const navigate = useNavigate();
  const [transfer, _transfer] = useState({})
  useEffect(() => {
    console.log("111");
    let text = window.location.search.substring(1);
    console.log('PatrolMap?' + text);
    _transfer(JSON.parse(window.sessionStorage.getItem('PatrolMap?' + text)))
  }, [])
  // if (!viewpicture || !transfer) {
  //   console.log('21312');
  //   window.location.replace('/PatrolResult')
  // }

  return (
    <div className="NodeMap hei100 disFlex flexDirCol" style={{ height: '100vh' }}>
      {/* <Header /> */}
      <div className='flex1 posRel'>
        {MapComponents(transfer)}
      </div>
    </div>
  )
}
